<!-- Centered Layout (for account suspended, etc.) -->
<div *ngIf="data.centeredLayout" class="centered-dialog-container">
  <mat-icon *ngIf="data.icon" class="centered-icon" [color]="data.iconColor || 'warn'">
    {{ data.icon }}
  </mat-icon>
  <p class="centered-message">{{ data.description }}</p>
  <button mat-raised-button color="primary" class="centered-button" (click)="onConfirmClick()">
    {{ data.confirmButtonText || 'OK' }}
  </button>
</div>

<!-- Traditional Layout (for regular confirmations) -->
<ng-container *ngIf="!data.centeredLayout">
  <h5 mat-dialog-title class="header">
    <mat-icon *ngIf="data.icon" class="me-2" [color]="data.iconColor || 'warn'">{{ data.icon }}</mat-icon>
    {{ data.title }}
  </h5>
  <div mat-dialog-content class="pb-5 pt-5">
    <p>{{ data.description }}</p>
  </div>
  <div mat-dialog-actions align="end" class="footer">
    <button mat-button mat-dialog-close color="warn" *ngIf="data.showCancelButton !== false">Cancel</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onConfirmClick()" color="primary">
      {{ data.confirmButtonText || 'Confirm' }}
    </button>
  </div>
</ng-container>
